<template>
  <div class="box">
    <div class="Date">
      <div
        v-for="item in site"
        :key="item.name"
        :style="{ color: item.color }"
        @click="filterSite(item.name)"
      >
        <span>{{ item.num }}</span>
        <p>{{ item.name }}</p>
      </div>
    </div>
    <img src="../../../assets/image/发光2.png" class="bg" />
    <div class="list" >
      <dv-scroll-board :config="config" @click="onclick" style="height: 100%" />
    </div>
  </div>
</template>

<script>
import { dateFormat } from "@/utils/tools";
import Api from "@/api";

export default {
  data() {
    return {
      timer: null,
      config: {},
      data: { val: {}, arr: [] },
      site: [
        { name: "站点总数", num: 0, color: "#00DADA", arr: [] },
        { name: "满桩", num: 0, color: "#ED462F", arr: [] },
        { name: "偏多", num: 0, color: "#FF7C14", arr: [] },
        { name: "正常", num: 0, color: "#42C351", arr: [] },
        { name: "偏少", num: 0, color: "#FFC900", arr: [] },
        { name: "空桩", num: 0, color: "#1F8FFB", arr: [] },
      ],
    };
  },
  created() {
    // 2分钟刷新一次数据
    this.loading = true;
    this.initData();
  },
  watch: {
    selfAreaId(v, o) {
      this.initData();
    },
  },
  props: {
    selfAreaId: {
      default: "",
      type: String
    },
  },
  methods: {
    initData() {
      if(!this.selfAreaId){
        return
      }
      const vm = this;
      // 还原
      vm.site = [
        { name: "站点总数", num: 0, color: "#00DADA", arr: [] },
        { name: "满桩", num: 0, color: "#ED462F", arr: [] },
        { name: "偏多", num: 0, color: "#FF7C14", arr: [] },
        { name: "正常", num: 0, color: "#42C351", arr: [] },
        { name: "偏少", num: 0, color: "#FFC900", arr: [] },
        { name: "空桩", num: 0, color: "#1F8FFB", arr: [] }
      ];
      vm.data = { val: {}, arr: [] };
      Api.dashboard({
        v: 1,
        selfAreaId: vm.selfAreaId,
      })
        .then((res) => {
          if (res.code === 200) {
            vm.initSum(res.data.map);
            vm.initconfig(
              res.data.siteMessage && res.data.siteMessage.length > 5
                ? res.data.siteMessage.slice(0, 10)
                : res.data.siteMessage
            )
            console.log('站点状态数据为空 - dispatchGuide')
          } else {
            vm.$message.warning(res.message);
          }
        })
        .catch((err) => {
          vm.$message.warning(err)
        })
    },
    initSum(mapsite) {
      if (mapsite && mapsite.length > 0) {
        mapsite.forEach((val) => {
          this.site[0].num++;
          switch (val.flag) {
            case 0:
              this.site[5].num++;
              break;
            case 4:
              this.site[4].num++;
              break;
            case 2:
              this.site[1].num++;
              break;
            case 3:
              this.site[2].num++;
              break;
            default:
              this.site[3].num++;
              break;
          }
        });
      }
    },
    initconfig(siteMessage) {
      if (siteMessage && siteMessage.length > 0) {
        let arr = siteMessage.map((val) => {
          switch (val.messageType) {
            case "empty":
              val.status = "空桩";
              val.color = this.site[5].color;
              break;
            case "less":
              val.status = "偏少";
              val.color = this.site[4].color;
              break;
            case "full":
              val.status = "满桩";
              val.color = this.site[1].color;
              break;
            case "more":
              val.status = "偏多";
              val.color = this.site[2].color;
              break;
            default:
              val.color = this.site[3].color;
              val.status = "正常";
              break;
          }
          return val;
        });
        this.data.val = arr;
        this.data.arr = this.data.val.map((val) => {
          return [
            dateFormat(val.createTime, "yyyy-MM-dd hh:mm"),
            val.siteName,
            val.num + "辆",
            `<span style="color:${val.color};">${val.status}</span>`,
            '<span style="color:#00DADA;cursor:pointer">详情</span>',
          ];
        });
      }
      this.config = {
        columnWidth: [, 100, 50, 50, 50, 50],
        data: this.data.arr
      };
    },
    filterSite(status) {
      this.$emit("filterSite", status);
    },
    onclick(val) {
      let index = val.rowIndex;
      if (val.ceil.indexOf("详情") !== -1) {
        const data = {
          ...this.data.val[index],
          type: 4,
        };
        this.$emit("showModel", data);
        return;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="less" scoped>
.box {
  padding: 0 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .list {
    flex: 1;
    overflow: hidden;
  }
  .Date {
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    flex: 0 0 39px;
    cursor: pointer;
    > div {
      flex: 1;
      text-align: center;
      p {
        margin-top: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
      }
      span {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 18px;
      }
    }
  }
  .bg {
    flex: 0 0 14px;
    display: block;
    margin: 10px 0;
    width: 100%;
  }
}

.row-item {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
